/** Pamphlet — document knowledge definition. Pure data. */
export default {
  id: 'pamphlet',
  name: 'Pamphlet',
  description: 'A compact informational fold-out focused on a single topic or cause.',
  purpose: 'Information & Education',
  recommendedSizes: [
    { name: 'A5 Bi-fold', width: 2480, height: 1748, unit: 'px' },
    { name: 'A5', width: 1748, height: 2480, unit: 'px' },
  ],
  supportedOrientations: ['portrait', 'landscape'],
  supportsMultiplePages: true,
  supportsBleed: true,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: false,
  supportsPricing: false,
  supportsCTA: true,
  supportsOffers: false,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Cover', 'Introduction', 'Key Points', 'Details', 'Contact'],
};
